export const changeSelectedDatasetnameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_Selecteddataset":
      return action.payload.selecteddataset;
    default:
      return state;
  }
};
